module.exports = __webpack_public_path__ + "img/apt-2@2x.c920d3e4.jpg";